export default __webpack_public_path__ + "static/media/mindmap_douleur.fe3196e2.png";